import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const FilterStopIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M6 7C6 6.44772 6.44772 6 7 6C7.55228 6 8 6.44772 8 7V11C8 11.5523 7.55228 12 7 12C6.44772 12 6 11.5523 6 11V7Z"
        fill={fillColor || '#FF5B27'}
      />
      <path
        d="M10 7C10 6.44772 10.4477 6 11 6C11.5523 6 12 6.44772 12 7V11C12 11.5523 11.5523 12 11 12C10.4477 12 10 11.5523 10 11V7Z"
        fill={fillColor || '#FF5B27'}
      />
      <circle cx="9" cy="9" r="8" stroke="#FF5B27" strokeOpacity="0.2" />
      <path
        d="M8.99993 1C13.4182 1 16.9999 4.58172 16.9999 9C16.9999 13.4183 13.4182 17 8.99993 17C6.71207 17 4.64852 16.0396 3.19043 14.5"
        stroke={fillColor || '#FF5B27'}
      />
    </svg>
  );
};

export { FilterStopIcon };
